:host {
    display: flex;
    flex-wrap: wrap;
}
